import React, { ForwardedRef } from "react";
import MuiDrawer from "@mui/material/Drawer";

import { DrawerProps } from "./Drawer.types";
import { useDrawerStyles } from "./DrawerStyles";

export function Drawer(
  props: DrawerProps,
  ref: ForwardedRef<unknown>
): JSX.Element {
  const { children, ...other } = props;

  const drawerClasses = useDrawerStyles(props);

  return (
    <MuiDrawer
      {...other}
      classes={drawerClasses}
      ref={ref as React.Ref<HTMLDivElement>}
    >
      {children}
    </MuiDrawer>
  );
}

export default React.forwardRef(Drawer);
